import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from '../services/notification.service';
import { IZPNotification } from '../models/notification.model';
import { NotificationType } from '../models/notification-type.enum';

@Component({
  selector: 'app-notification-bubble',
  templateUrl: './notification-bubble.component.html',
  styleUrls: ['./notification-bubble.component.scss']
})
export class NotificationBubbleComponent implements OnInit {

  constructor(private notifications: NotificationService) { }

  @Input() public timeout: number = 5;
  private latest: IZPNotification;

  ngOnInit() {
    this.notifications.currentMessage.subscribe(n => {
      if (n) {
        this.latest = n;
        if (this.timeout) {
          setTimeout(() => {
            this.latest = undefined;
            this.notifications.clearMessage();
          }, this.timeout * 1000);
        }
      }
    })
  }

  dismiss() {
    this.latest = undefined;
    this.notifications.clearMessage();
  }

}
